<div class="container">
	<div class="header-container">
		<mat-icon (click)="backButton()">clear</mat-icon>
	</div>

	<div class="iframe-container">
		<iframe src="https://knowledge.lolly.com/"></iframe>
	</div>
</div>
